import { render, staticRenderFns } from "./EgitimQuiz.vue?vue&type=template&id=8ada14da&"
import script from "./EgitimQuiz.vue?vue&type=script&lang=js&"
export * from "./EgitimQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports